import { Image } from "expo-image";
import { List, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { FlatCard } from "../Cards/FlatCard";

type Props = {
	title: string;
	subtitle: string;
	imageUri: string;
	onPress: () => void;
};

const CMETypeCard = ({ title, subtitle, imageUri, onPress }: Props) => {
	const theme = useAppTheme();

	return (
		<FlatCard>
			<List.Item
				title={<Text variant="bodyMedium">{title}</Text>}
				description={<Text variant="bodySmall">{subtitle}</Text>}
				onPress={onPress}
				left={(p) => (
					<List.Icon
						{...p}
						icon={() => (
							<Image
								source={{ uri: imageUri }}
								contentFit="cover"
								style={{
									width: 48,
									height: 48,
									borderRadius: 24,
									borderWidth: 1,
									borderColor: theme.colors.outlineVariant,
									backgroundColor: theme.colors.surfaceVariant,
								}}
							/>
						)}
					/>
				)}
				right={(p) => <List.Icon {...p} icon="information-outline" />}
			/>
		</FlatCard>
	);
};

export default CMETypeCard;
